var map = {
	"./CervezaErdingerPikantus.jpg": "2a28",
	"./CervezaMinervaDiosaBlanca.jpg": "2992",
	"./CervezaMinervaITA.jpg": "0269",
	"./CervezaMinervaPaleAle.jpg": "069d",
	"./CervezaMinervaStour.jpg": "e365",
	"./cerveza1.png": "e232",
	"./cerveza2.png": "edcb",
	"./stella_artois_lager_330ml.png": "7f6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db7a";